export const StatisticsTypesList = [
  {name: 'Routing attempts',           value: 'SOURCE_CALL_1ST_ROUTING_ATTEMPTS'          },
  {name: 'Alternative attempts',       value: 'SOURCE_CALL_ATLTERNATIVE_ROUTING_ATTEMPTS' },
  {name: 'Unsuccessful routes',        value: 'SOURCE_CALL_FAILED_ROUTING_ATTEMPTS'       },
  {name: 'Drop routing requests',      value: 'SOURCE_CALL_DROP_ROUTING_REQUEST'          },
  {name: 'Destinations Not Routable',  value: 'SOURCE_CALL_DISCARD_ROUTING_ATTEMPTS'      },
  {name: 'Destination calls',          value: 'DESTINATION_CALL'                          },
  {name: 'Transient calls',            value: 'TRANSIENT_CALL'                            },
  {name: 'Routing first match',        value: 'ROUTING_RULE_ACTION_1ST_MATCH'             },
  {name: 'Routing second match',       value: 'ROUTING_RULE_ACTION_2ND_MATCH'             },
  {name: 'Routing third match',        value: 'ROUTING_RULE_ACTION_3RD_MATCH'             },
  {name: 'Routing rules attempts',     value: 'ROUTING_RULE_ACTION_TRY'                   },
  {name: 'Routing rules failures',     value: 'ROUTING_RULE_ACTION_FAIL'                  },
  {name: 'No match rules',             value: 'NO_MATCH_RULE'                             },
  {name: 'Hits',                       value: 'HITS'                                      },
  {name: 'Average session count',      value: 'SESSION_COUNT_AVERAGE'                     },
  {name: 'Minimum session count',      value: 'SESSION_COUNT_MIN'                         },
  {name: 'Maximum session count',      value: 'SESSION_COUNT_MAX'                         },
  {name: 'Registration routed',        value: 'REGISTRATION_ROUTED'                       },
  {name: 'Registration unrouted',      value: 'REGISTRATION_UNROUTED'                     },
  {name: 'Registration blocked',       value: 'REGISTRATION_BLOCKED'                      },
  {name: 'Peer Connections',           value: 'QUOTA_PEER_CONNECTION'                     },
  {name: 'Resource Groups',            value: 'QUOTA_RESOURCE_GROUP'                      },
  {name: 'Accumulated Duration',       value: 'ACCUMULATED_DURATION'                      },
  {name: 'Incoming Average',           value: 'SESSION_INCOMING_AVERAGE'                 },
  {name: 'Incoming Minimum',           value: 'SESSION_INCOMING_MIN'                     },
  {name: 'Incoming Maximum',           value: 'SESSION_INCOMING_MAX'                     },
  {name: 'Outgoing Average',           value: 'SESSION_OUTGOING_AVERAGE'                 },
  {name: 'Outgoing Minimum',           value: 'SESSION_OUTGOING_MIN'                     },
  {name: 'Outgoing Maximum',           value: 'SESSION_OUTGOING_MAX'                     },
  {name: 'Total Average',           value: 'SESSION_TOTAL_AVERAGE'                    },
  {name: 'Total Minimum',           value: 'SESSION_TOTAL_MIN'                        },
  {name: 'Total Maximum',           value: 'SESSION_TOTAL_MAX'                        }
];

export const DateTimeUnitTypeList = [
  {name: 'Months',    value: 'MONTH'  },
  {name: 'Weeks',     value: 'WEEK'   },
  {name: 'Days',      value: 'DAY'    },
  {name: 'Hours',     value: 'HOUR'   },
  {name: 'Minutes',   value: 'MINUTE' }
];
